export enum OrderStatus {
  INGRESADA = 'ADMITTED',
  RECIBIDA = 'RECEIVED'
}
